export default "__VITE_ASSET__6GVqhAAi__"